var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3735 12.9997L1.3735 12.9998L1.37362 16.5857L1.37367 18.0948L2.44064 17.0276L7.73185 11.735C7.73193 11.7349 7.73202 11.7348 7.7321 11.7347C7.87887 11.5885 8.11607 11.5884 8.26297 11.7344C8.40901 11.8813 8.40892 12.1187 8.2627 12.2655C8.26262 12.2656 8.26254 12.2657 8.26247 12.2658L2.9703 17.5574L1.90321 18.6244H3.41223H6.99776C7.20467 18.6244 7.37298 18.7927 7.37298 18.9997C7.37298 19.2068 7.20467 19.375 6.99776 19.375H0.99828C0.79137 19.375 0.623059 19.2068 0.623059 18.9997V12.9997C0.623059 12.7927 0.79137 12.6244 0.99828 12.6244C1.20519 12.6244 1.3735 12.7927 1.3735 12.9997Z",
    fill: "white",
    stroke: "#38393C",
    strokeWidth: 1.25002
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6258 3.41435V1.90515L17.5588 2.97245L12.2675 8.26506C12.1208 8.4115 11.8833 8.41166 11.7363 8.26553C11.5904 8.1186 11.5905 7.88132 11.7367 7.73452C11.7367 7.73443 11.7368 7.73434 11.7369 7.73425L17.0291 2.4426L18.0962 1.37562L16.5872 1.37562H13.0016C12.7947 1.37562 12.6264 1.20737 12.6264 1.00032C12.6264 0.793262 12.7947 0.625012 13.0016 0.625012H19.0011C19.208 0.625012 19.3763 0.793262 19.3763 1.00032V7.00029C19.3763 7.20715 19.2081 7.37548 19.001 7.37548C18.7941 7.37548 18.6258 7.20723 18.6258 7.00017V3.41435Z",
    fill: "white",
    stroke: "#38393C",
    strokeWidth: 1.25002
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.d017f4be071efe92aa57dd2d3148b64b.svg";
export { ForwardRef as ReactComponent };